import React, { createContext, useContext, useEffect, useState } from "react";
import { getCookies, setCookies } from "../utils/Helpers";
import APIServices from "../services/APIServices";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(getCookies("adminToken"));
  const [user, setUser] = useState(false);
  const [isSuperAdmin, setSuperAdmin] = useState(false);

  useEffect(() => {
    if (!token) return;
    const fetchUserInfo = async () => {
      if (token) {
        let userRes = await APIServices.post(`/admin/detail?token=${token}`);
        setUser(userRes.data);
        if (userRes?.data?.userType?.role === "superadmin") {
          setSuperAdmin(true);
        } else {
          setSuperAdmin(false);
        }
      }
    };
    fetchUserInfo();
  }, [token]);

  const logout = () => {
    setUser(null);
    setCookies("adminToken", null);
    refreshToken("");
  };

  // If user logoff or login, update token from child component
  const refreshToken = (newToken) => {
    setToken(newToken);
  };

  return (
    <AuthContext.Provider value={{ user, refreshToken, logout, token , isSuperAdmin}}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
